function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "9.795%",
  y1: "25.852%",
  x2: "99.779%",
  y2: "43.168%",
  id: "house-study_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D61772",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A0398E",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56 30v26H32V42h-8v14H0V30h56zm-8 8h-7v9h7v-9zm-33 0H8v9h7v-9zm9-26v8h-6v-8h6zm14 0v8h-6v-8h6zm13-4L28 0 5 8m5-1.667V25M46 6.182V25",
  transform: "translate(1 2)",
  stroke: "url(#house-study_svg__a)",
  strokeWidth: 2,
  fill: "none",
  strokeLinecap: "square"
});

function SvgHouseStudy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 59"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1OCA1OSI+PGRlZnM+PGxpbmVhckdyYWRpZW50IHgxPSI5Ljc5NSUiIHkxPSIyNS44NTIlIiB4Mj0iOTkuNzc5JSIgeTI9IjQzLjE2OCUiIGlkPSJhIj48c3RvcCBzdG9wLWNvbG9yPSIjRDYxNzcyIiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iI0EwMzk4RSIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHBhdGggZD0iTTU2IDMwdjI2SDMyVjQyaC04djE0SDBWMzBoNTZ6bS04IDhoLTd2OWg3di05em0tMzMgMEg4djloN3YtOXptOS0yNnY4aC02di04aDZ6bTE0IDB2OGgtNnYtOGg2em0xMy00TDI4IDAgNSA4bTUtMS42NjdWMjVNNDYgNi4xODJWMjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMikiIHN0cm9rZT0idXJsKCNhKSIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz48L3N2Zz4=";
export { SvgHouseStudy as ReactComponent };